import { render, staticRenderFns } from "./NewMarketProfile.vue?vue&type=template&id=adb099e0"
import script from "./NewMarketProfile.vue?vue&type=script&lang=js"
export * from "./NewMarketProfile.vue?vue&type=script&lang=js"
import style0 from "./NewMarketProfile.vue?vue&type=style&index=0&id=adb099e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports